import React from 'react';

const Treatments = () => {
    return (
        <section id="treatments" className="block spacer p-top-xl p-bottom-xl">
            <div className="wrapper">
                <div className="title text-max-width-2">
                    <h2>Treatments</h2>
                </div>

                <div className="description text-max-width-2">
                    <p>Here at Botany Physio we offer a wide variety of treatments: </p> <br />
                </div>

                <div className="treatment-content p-bottom-xl">
                    <h4>Head Pain</h4>
                    <p>This includes Headaches, Migraines, and Sinusitis.</p>
                    <p>
                       These conditions are treated with a combination of joint mobilisations of the upper spine / neck, soft tissue massage & trigger point release, and specific exercises designed to help settle headaches and improve your posture. In addition, sinusitis is treated with ultrasound therapy and acupuncture.
                    </p>
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Neck Pain</h4>
                    <p>This includes Whiplash Injuries, Neck Sprains, Cervical Disc Pathologies, and Radiculopathy (nerve pain).</p>
                    <p>
                        A combination of treatment techniques is used for these conditions, including neck joint mobilisations, soft tissue massage & trigger point release therapy, stretches, neck strengthening exercises, and correction of faulty movement patterns or prolonged posture that may contribute to ongoing pain.
                    </p>
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Shoulder Pain</h4>
                    <p>This includes Shoulder & Upper Arm Sprains, Rotator Cuff Sprains, Shoulder Bursitis, and Post-op Rehab for Rotator Cuff Repairs & Shoulder Surgeries</p>
                    <p>
                        Standard techniques of joint mobilisations, soft tissue massage, and trigger point release therapy (sometimes including dry needling and acupuncture), stretches, progressive strengthening exercises, and retraining of posture and shoulder blade position / stability is used to rehabilitate these conditions. Kinesiotape and strapping can also help in recovery.
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Arm, Wrist & Hand Pain</h4>
                    <p>This includes Elbow Sprains, Tennis and Golfer’s Elbow (Lateral and Medial Epicondylitis), Forearm Sprains, and Wrist, Finger & Thumb Sprains (Tendinopathies) </p>
                    <p>
                        Along with standard physiotherapy treatment techniques (joint mobilisations, soft tissue massage, trigger point release, stretches, and strengthening exercises), we may also use kinesiotaping and / or strapping, elbow, wrist and thumb braces, and dry needling or acupuncture can be helpful to restore full function to your upper limb injury. Sometimes, arm or even hand pain or pins and needles and numbness, could be referring from a problem in your neck. Following a thorough assessment we may require to treat the neck to resolve the injury.
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Chest & Rib Pain</h4>
                    <p>This includes Rib Sprains and Thoracic (Mid to Upper Back) Sprains </p>
                    <p>
                        Standard physiotherapy techniques work very well to resolve problems in the midback or ribs.This includes joint mobilisations and manipulations, as well as muscle release techniques and acupuncture. Then exercise, strapping, postural and ergomomic advice are used for ongoing rehabilitation management.
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Back Pain</h4>
                    <p>This includes Lumbar (lower back) Sprains, Lumbar Disc Pathologies & Radiculopathy (nerve pain), Spondylosis (degenerative joints) & Osteoarthritis</p>
                    <p>
                        Along with standard physiotherapy manual therapy techniques, western medical acupuncture can be effective to ease pain, spasm and inflammation. McKenzie back exercises are often used to help resolve back pain. Neural mobilising techniques can be very beneficial in the case of sciatica. Core stabilising evidence based exercises are key to any back injury and future injury prevention, and we are qualified to provide you with a range of specialised exercises. 
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Buttock, Hip, Groin & Thigh Pain</h4>
                    <p>
                        This includes Hip Sprains, Hip Bursitis, Osteoarthritis (OA) Hips, Post-op Total Hip Joint Replacement (THJR) Rehabilitation, Sacroiliac 
                        Joint Sprains, Dysfunction & Instability, and Hamstrings, Quads & Groin Strains or Injuries.
                    </p>
                    <p>
                        Mobilisation techniques are excellent rehab tools to regain mobility in painful, restricted, or arthritic hips, while in the case of hip bursitis, kinesiotaping, dry needling / acupuncture, and correcting muscle balance with an individualised programme of evidence based stability exercises around the hip can make a big difference. Hip pain may sometimes be a secondary symptom of problems with your back or feet, such as pronation, feet that roll in too much. For this reason, we will often do a brief assessment of your feet. Sometimes your buttock, hip, groin, or thigh pain may be referred pain from either the lower back, the sacroiliac joints, or even just from muscle trigger points (knots) in the buttock. A thorough assessment will help us determine the cause of your pain, and you will be treated accordingly.
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Knee Pain</h4>
                    <p>
                        This includes Knee Sprains, Knee Ligaments Strains (MCL, LCL, ACL, PCL), Knee Meniscus Tears, Osteoarthritic Knees, Post-operative Knee 
                        Rehab for Ligament Repairs, Meniscectomies & Total Knee Joint Replacements, Patello-femoral Pain & Patella Tracking Problems, 
                        Osgood-Schlatter’s Disease (knee pain in children)
                    </p>
                    <p>
                        Knee pain can be treated with various techniques, from frictioning the ligaments and releasing trigger points, using evidence based western medical acupuncture to reduce swelling and inflammation, and strapping or kinesiotaping to support the knee. Exercises for the knee are always important as your kneecap position and how it moves relies very strongly on the inner thigh muscles being equally as strong as the outer thigh muscles.
                        Most knee injuries also respond very well to a structured exercycle regime – cycling helps to keep the knee gently moving, strengthens the muscles, and helps to lubricate the joint and create a healing environment in the joint by increasing the production of synovial (joint) fluid.
                        Knee pain can also sometimes be linked to faulty foot biomechanics. 
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Lower Leg & Foot Pain</h4>
                    <p>
                        This includes Calf Strains, Shin Splits, Achilles Tendon Strains & Tendinopathies, Sever's Disease (heel pain in children), Ankle Sprains, Heel Pain, Foot Pain, Plantar Fasciitis (arch pain), Plantar Warts, and Toe Strains & Injuries
                    </p>
                    <p>
                        Many times ongoing Achilles, heel, or foot pain may be the result of poor foot biomechanics. Feet that roll in too much cause certain muscles and tendons in the lower leg and foot to overstretch and become inflamed, leading to issues such as shin splints, heel spurs, and plantar fasciitis. We can assess your feet and alignment and advise the best management.
                    </p> 
                    <br />
                </div>

                <div className="treatment-content">
                    <h4>Other</h4>
                    <p>
                        This includes Muscle Imbalances & Postural Problems, Overuse Syndromes & Repetitive Strain Injuries, and Contusions & Hematomas.
                    </p>
                    <p>
                        A thorough physical assessment will let us determine where you may have weak muscles that may lead to postural problems and muscle imbalances. We will be able to prescribe you with a specific exercise program to help improve your muscle strength, as well as give you advice about correct sitting, standing, and sleeping positioning, and ergonomics
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Treatments;
